var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useState, useEffect, useMemo } from 'react';
import { createPrefixCls } from '../_utils/string';
import Modal from '../modal';
import PickerView from './picker-view';
const prefixCls = createPrefixCls('picker');
export const Picker = (_a) => {
    var { visible: propVisible, disabled, onClear, onConfirm, onCancel, onClose, children } = _a, restProps = __rest(_a, ["visible", "disabled", "onClear", "onConfirm", "onCancel", "onClose", "children"]);
    const [visible, setVisible] = useState(false);
    const isVisible = useMemo(() => {
        return propVisible === undefined ? visible : propVisible;
    }, [propVisible, visible]);
    useEffect(() => {
        setVisible(!!propVisible);
    }, [propVisible]);
    const handleClick = useCallback((e) => {
        if (disabled) {
            return;
        }
        setVisible(true);
        if (React.isValidElement(children)) {
            children.props.onClick && children.props.onClick(e);
        }
    }, [children, disabled]);
    const handleClose = useCallback(() => {
        if (visible) {
            setVisible(false);
            onClose && onClose();
        }
    }, [onClose, visible]);
    const handleCancel = useCallback(() => {
        setVisible(false);
        onCancel && onCancel();
    }, [onCancel]);
    const handleClear = useCallback(() => {
        setVisible(false);
        onClear && onClear();
    }, [onClear]);
    const handleConfirm = useCallback((value) => {
        setVisible(false);
        onConfirm && onConfirm(value);
    }, [onConfirm]);
    return (React.createElement(React.Fragment, null,
        children &&
            React.isValidElement(children) &&
            React.cloneElement(children, {
                onClick: handleClick
            }),
        React.createElement(Modal, { className: prefixCls('body'), visible: isVisible, onClose: handleClose, maskClosable: false },
            React.createElement(PickerView, Object.assign({ onCancel: handleCancel, onClear: handleClear, onConfirm: handleConfirm }, restProps)))));
};
export default Picker;
